'use client'

import { cn } from '@/lib/utils'

interface VisualPatternProps {
  variant?: 'default' | 'subtle'
}

/**
 * Ampersand mesh gradient background — animated depth blobs.
 */
export function VisualPattern({ variant = 'default' }: VisualPatternProps) {
  const opacity = variant === 'subtle' ? 'opacity-30' : 'opacity-100'

  return (
    <div
      className={cn(
        'pointer-events-none fixed inset-0 -z-10 overflow-hidden',
        opacity
      )}
      aria-hidden='true'
    >
      <div className='absolute -right-[10%] -top-[20%] h-[500px] w-[500px] animate-float rounded-full bg-brand-purple/8 blur-3xl' />
      <div className='absolute -left-[10%] top-[20%] h-[400px] w-[400px] animate-float-delayed rounded-full bg-brand-cornflower/10 blur-3xl' />
      <div className='absolute bottom-0 left-1/3 h-[350px] w-[350px] animate-float rounded-full bg-brand-cornflower/6 blur-3xl' />
    </div>
  )
}
